import React, { forwardRef, useState } from 'react';
import { FormGroup } from 'react-bootstrap';
import { resolveQuantityInput } from './inventoryFormRules';

export const QuantityInput = forwardRef(({ value, onChange, max, min = 1, disabled = false, placeholder, style, id, name = 'item.Quantity', className = 'form-control', allowEmpty = true }, ref) => {
    const [isCleared, setIsCleared] = useState(false);

    function handleChange(e) {
        const resolved = resolveQuantityInput(e.target.value, max);
        if (resolved === null) return;
        // With `allowEmpty` off the caller keeps a numeric value it cannot express as empty,
        // so an emptied field is kept in the input alone and the value comes back on blur.
        if (resolved === '' && !allowEmpty) {
            setIsCleared(true);
            return;
        }
        setIsCleared(false);
        onChange(resolved);
    }

    return (
        <FormGroup style={{ marginBottom: '0px', ...style }}>
            <input ref={ref}
                id={id}
                className={className}
                type="number"
                min={min}
                max={max ?? undefined}
                name={name}
                placeholder={placeholder}
                disabled={disabled}
                value={isCleared ? '' : (value ?? '')}
                onChange={handleChange}
                onBlur={() => setIsCleared(false)}
                autoComplete="off" />
        </FormGroup>
    );
});
